module.exports = __webpack_public_path__ + "img/card_7.e3275e0c.png";